import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';
import { MediaPlayer } from 'dashjs/dist/dash.mediaplayer.min';

let autoplayHasBeenInit = false;

const debug = (data) => {
    if (pageData.debug) console.log(data);
}

const removeClass = (element, className) => {
    if (element.classList) {
        element.classList.remove(className);
    } else {
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
}

const addClass = (element, className) => {
    if (element.classList) {
        element.classList.add(className);
    } else {
        element.className += ' ' + className;
    }
}

const autoplay = (player) => {
    if (pageData.autoplay && !autoplayHasBeenInit) {
        autoplayHasBeenInit = true;
        debug("Init autoplay");
        let playing = false;
        if(pageData.isIos) {
            player.addEventListener("playing", function() {
                playing = true;
            });
        }
        function _autoplay() {
            if (!pageData.isIos) playing = player.playing;
            debug("Autoplay", playing);
            if (!playing) {
                player.play().catch(function() {});
                setTimeout(function() {
                    _autoplay();
                }, 500);
            }
        }
        _autoplay();
    }
}

const resetToMp4Video = () => {
    if(window.dashPlayer) window.dashPlayer.reset();
    debug("Player: H264 mode");
}

const initPlayer = () => new Promise(resolve => {
    if (pageData.mpd) {
        if (typeof (window.MediaSource || window.WebKitMediaSource) === "function") {
            debug(`Player: DASH mode - ${pageData.mpd}`);
            const dashPlayer = MediaPlayer().create();
            // If Debug has been imported from dashjs, then switch dashjs to debug mode
            if (typeof Debug !== 'undefined') dashPlayer.updateSettings({ 'debug': { 'logLevel': pageData.debug === 2 ? Debug.LOG_LEVEL_DEBUG : Debug.LOG_LEVEL_NONE }});
            dashPlayer.initialize(document.getElementById('danimPlayer'), pageData.mpd, /* pageData.autoplay */ false);
            dashPlayer.on('streamInitialized', () => {
                const bitrates = dashPlayer.getBitrateInfoListFor("video");
                // Set best bitrate as default in auto mode
                dashPlayer.updateSettings({
                    streaming: {
                        abr: {
                            autoSwitchBitrate: {
                                video: true
                            },
                            initialBitrate: {
                                video: bitrates.length - 1
                            }
                        }
                    }
                });
                const qualities = []
                bitrates.forEach(stream => {
                    const { width, height } = stream;
                    const quality = width > height ? height : width;
                    if (qualities.indexOf(quality) === -1) qualities.push(quality);
                });
                qualities.reverse();
                const player = initPlyrPlayer({
                    quality: {
                        default: qualities[0],
                        options: qualities,
                        forced: true,        
                        onChange: quality => {
                            dashPlayer.updateSettings({
                                streaming: {
                                    abr: {
                                        autoSwitchBitrate: {
                                            video: false
                                        }
                                    }
                                }
                            });
                            for (let i=0; i<bitrates.length; i++) {
                                const { width, height, qualityIndex } = bitrates[i];
                                const ref = width > height ? height : width;
                                if (ref === quality) {
                                    dashPlayer.setQualityFor("video", qualityIndex, true);
                                    break;
                                }
                            }
                        }
                    },
                    settings: ['quality']
                });

                dashPlayer.on('canPlay', () => {
                    autoplay(player);
                });
                resolve(player);
            });
            dashPlayer.on('error', (err) => {
                debug("Dash player error");
                debug(err);
                resetToMp4Video();
                resolve(initPlyrPlayer());
            });
            window.dashPlayer = dashPlayer;
        }
    }
    if (!window.dashPlayer) {
        const player = initPlyrPlayer();
        autoplay(player);
        resolve(player);
    }
})

const initCta = (video) => {
    if (pageData.cta) {
        const { title, url } = pageData.cta;
        const danimCta = document.createElement("a");
        var fullscreenOverlay = document.createElement("div");
        addClass(danimCta, 'danimCta');
        addClass(fullscreenOverlay, 'fullscreenOverlay');
        addClass(danimCta, 'fade');
        addClass(fullscreenOverlay, 'fade');
        danimCta.setAttribute('href', url);
        danimCta.setAttribute('target', '_blank');
        danimCta.textContent = title;
        danimCta.style.cssText = `background-color: #${pageData.color}`;
        var playerDiv = document.getElementById("player");
        playerDiv.appendChild(danimCta); 
        if (pageData.isIos) {
            playerDiv.insertBefore(fullscreenOverlay, playerDiv.firstChild);
        } else {
            document.getElementsByClassName("plyr__video-wrapper")[0].appendChild(fullscreenOverlay); 
        }
        const video = document.getElementById('danimPlayer');
        video.ontimeupdate = function() {
            const { currentTime, duration } = video;
            if (duration - currentTime <= 1) {
                addClass(danimCta, 'in');
                addClass(fullscreenOverlay, 'in');
            } else {
                removeClass(danimCta, 'in');
                removeClass(fullscreenOverlay, 'in');
            }
        }
    }
}

const initPlyrPlayer = (options = {}, onQualityChange = null) => {
    const video = document.getElementById('danimPlayer');
    let player = null;
    if (pageData.isIos) {
        player = video;
    } else {
        const controls = pageData.controls ? ['play-large', 'pip', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] : ['play-large'];
        if (options.quality) controls.push('settings');
        player = new Plyr(video, {
            volume : pageData.muted ? 0 : 0.5,
            muted : pageData.muted ? true : false,
            storage: { enabled: false },
            controls,
            ...options,
        });
        if (options.quality) {
            // Quick hack to init Quality switcher UI with "Auto" as default value
            document.querySelectorAll('button[data-plyr=settings]').forEach(el => {
                if (el.textContent.toLowerCase().indexOf('quality') !== -1) {
                    el.getElementsByClassName('plyr__menu__value')[0].textContent = 'Auto';
                }
            });
            document.querySelectorAll('button[data-plyr="quality"]').forEach(el => {
                el.setAttribute('aria-checked', false);
            });
        }
        if (onQualityChange) player.on('qualitychange', onQualityChange);
    }
    initCta();
    window.player = player;
    return player;
}

const handleTopBarDisplay = (player) => {
    const topBar = document.getElementById("topBar");
    const plyrPlayer = document.getElementsByClassName("plyr")[0];
    let yTopBar = -1;
    document.onmousemove = getCursor;
    function getCursor(e) {
        const topBarH = topBar.offsetHeight;
        const pageY = e.clientY;
        yTopBar = topBarH - pageY;
        if(yTopBar>=0) {
            removeClass(plyrPlayer, "plyr--hide-controls");
        }
    }

    const socialBloc = document.getElementById("socialBloc");
    const socialIcon = document.querySelector("#share i");
    document.getElementById("share").addEventListener("click", function() {
        if(this.getAttribute("data-trigger") == "open") {
            addClass(socialBloc, "in");
            this.setAttribute("data-trigger", "close");
            removeClass(socialIcon, "icon-share");
            addClass(socialIcon, "icon-cancel");
            player.pause();
        } else {
            removeClass(socialBloc, "in");
            this.setAttribute("data-trigger", "open");
            addClass(socialIcon, "icon-share");
            removeClass(socialIcon, "icon-cancel");
            if(!player.stopped) {
                setTimeout(function() {
                    player.play();
                },300);
            }
        }
    });

    setTimeout(function() {
        addClass(socialBloc, "fade");
        removeClass(socialBloc, "hide");
    }, 300);

    if (!pageData.isIos) {
        player.media.addEventListener('ready', (event) => {
            player.media.addEventListener('controlshidden', (event) => {
                if(yTopBar >= 0) {
                    removeClass(plyrPlayer, "plyr--hide-controls");
                } else {
                    addClass(topBar, "transparent")
                }
            });
            player.media.addEventListener('controlsshown', function(event) {
                if(yTopBar < 0) {
                    removeClass(topBar, "transparent");
                }
            });
        });
    }
}

const init = () => {
    debug(pageData);
    if (!pageData.error_code) {
        initPlayer().then(player => {
            handleTopBarDisplay(player);
            removeClass(document.getElementById("danimPlayer"), 'transparent');
        }).catch(e => console.error(e));
        return true;
    }
    return false;
}

init();